import React from 'react';
import PropTypes from 'prop-types';
import ServiceHistoryForm from '../forms/ServiceHistoryForm';

function ServiceHistoryPage({ form, validationErrors, onValidate }) {
  return (
    <div onBlur={onValidate}>
      <ServiceHistoryForm form={form} validationErrors={validationErrors} />
    </div>
  );
}

ServiceHistoryPage.propTypes = {
  form: PropTypes.object.isRequired,
  validationErrors: PropTypes.object,
  onValidate: PropTypes.func,
};

ServiceHistoryPage.defaultProps = {
  validationErrors: {},
  onValidate: () => {},
};

export default ServiceHistoryPage;
